export default "__VITE_ASSET__Cdu2ghET__"